import ArrowUpIcon from './ArrowUpIcon'

export default ArrowUpIcon
